/**
 * The words, read off the form.
 *
 * <x-registration.form> writes the whole registration language group to
 * data-registration-copy: the sentence shown under a field that fails a rule, and
 * the copy for the dialogs that follow. One group, because both are what this one
 * component says.
 *
 * It rides the form rather than a global, so a page gets it by drawing the component
 * and cannot be short of a key by forgetting to declare anything. That also lets two
 * forms sit on one page, which the speaker page does.
 *
 * Two accessors because the callers want different shapes: a validator wants the
 * whole map to index, a door wants one sentence and something to say if the key is
 * missing.
 */

const COPY = '[data-registration-copy]';

function parse(holder) {
    if (! holder) {
        return null;
    }

    try {
        return JSON.parse(holder.dataset.registrationCopy);
    } catch (error) {
        return null;
    }
}

/**
 * Every message this door can show, keyed as the language file keys them.
 *
 * Scoped to a form: the speaker page shows a sign-in beside a registration, so
 * "the form" is not a question the document can answer.
 */
export function fieldMessages(form) {
    const holder = form && (form.querySelector(COPY) || form.closest(COPY));

    return parse(holder) || {};
}

let copy = null;

/**
 * One sentence, for a dialog.
 *
 * Resolved once: the attribute is server-rendered and cannot change, and a dialog
 * firing mid-flow should not pay for a parse of the whole group. Not scoped to a
 * form either, unlike the field messages — a dialog is not raised by a field, and
 * only one form on a page carries this.
 *
 * The fallback is what shows on a page that draws no registration form at all.
 */
export function alertText(key, fallback) {
    if (! copy) {
        copy = parse(document.querySelector(COPY)) || {};
    }

    if (Object.prototype.hasOwnProperty.call(copy, key)) {
        return copy[key];
    }

    return typeof fallback !== 'undefined' ? fallback : key;
}
